<div class="main-container"
     style="width: fit-content; margin-right: 2px; border-radius: var(--border-radius); padding: 4px; width:calc(100% - 5px)"
     [class.horizontal]="(dataFormParagraph.cfgDFormParagraph.enumParagraphOrientationID == formsGlobals.PARAGRAPH_LAYOUT_HORIZONTAL) || forceHorizontalMode"
     [class.vertical]="(dataFormParagraph.cfgDFormParagraph.enumParagraphOrientationID == formsGlobals.PARAGRAPH_LAYOUT_VERTICAL) && !forceHorizontalMode"
     data-cy="forms-paragraph-container">
  <div data-cy="forms-paragraph-content">
    <div *ngIf="!collapsed && isGridLayout" data-cy="forms-paragraph-grid-layout">
      <div style="display: flex; margin-left: 1px; margin-bottom: 1px;" *ngFor="let row of itemRows; let rowIndex = index" 
           [ngStyle]="{'flex-direction': dataFormParagraph.cfgDFormParagraph.enumParagraphOrientationID == formsGlobals.PARAGRAPH_LAYOUT_VERTICAL ? 'column' : 'row'}"
           [attr.data-cy]="'forms-paragraph-row-' + rowIndex">
        <app-forms-item *ngFor="let item of row.items; index as i"
                        [isLocked]="isFormLocked || (item.cfgDFormItem.isReadOnlyForPatient && isPatientUser)"
                        (saveDataNoteEvent)="onSaveDataNote($event)"
                        [style.flex-basis]="item.cfgDFormItem?.ParagraphColumnWidth"
                        [actionsEnabled]="actionsEnabled"
                        [itemIndex]="i"
                        [CaseWorkItemFormsId]="CaseWorkItemFormsId"
                        [paragraphOrder]="dataFormParagraph.cfgDFormParagraph.ParagraphOrder"
                        [dataFormID]="dataFormID"
                        [saveEmitter]="saveEmitter"
                        [sideBySide]="dataFormParagraph.cfgDFormParagraph.enumItemLayoutID == formsGlobals.ITEM_LAYOUT_SBS"
                        [relatedRepeatingParagraph]="relatedRepeatingParagraph"
                        [dataFormItem]="item"
                        [attr.data-cy]="'forms-paragraph-item-' + rowIndex + '-' + i"></app-forms-item>
      </div>
    </div>
    <div *ngIf="collapsed && isGridLayout" class="collapsed-container" data-cy="forms-paragraph-collapsed">
      <button mat-button class="collapse-button" (click)="collapsed = false" data-cy="forms-paragraph-expand-button">
        <i class="material-icons" data-cy="forms-paragraph-expand-icon">expand_more</i>
      </button>
      <span data-cy="forms-paragraph-summary">{{ summary }}</span>
    </div>
  </div>
</div>
